<template>
    <div>
        <div v-if="windowWidth > 1279" class="s_1280">
            <!-- top panel -->
            <nav class="navbar wrapper navbar-expand-md fixed-top">
                <div class="col-5 menu-right">
                    <router-link to="/home">
                        <img class="logo-img" id="logo-btn" src="images/logo.png" />
                    </router-link>
                </div>
                <div class="col-7">
                    <div class="navigation">
                        <TopMenu></TopMenu>
                    </div>
                </div>
            </nav>

            <div class="main registration reg">
                <div class="container-fluid wrapper">

                    <div class="row auth-box reg-box">

                        <div class="col-3">
                            <div class="left-links">
                                <label class="done">Visa fee</label>
                                <label class="done">Application</label>
                                <label class="done">Documents</label>
                                <label class="passive" href="#">Check status</label>
                            </div>
                        </div>

                        <div class="col-8 offset-md-1">
                            <div class="reg status-box top98">
                                <div class="reg-completed">
                                    <div class="form-group row">
                                        <div class="col-12 box">
                                            <h2 v-if="status == 1">Application is in progress</h2>
                                            <h2 v-if="status == 4">Verification is in progress</h2>
                                            <h2 v-if="status == 5">Verification is in progress</h2>
                                            <h2 v-if="status == 6">Application is in progress</h2>
                                            <h2 v-if="status == 7">Application is approved</h2>
                                            <h2 v-if="status == 8">Application is rejected</h2>
                                            <h2 v-if="status == 9">Application is not verified</h2>
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <div class="col-4">
                                            <label>Application number</label>
                                            <label>Surname</label>
                                            <label>First name</label>
                                            <label>Passport number</label>
                                            <label>Date of birth</label>
                                            <label>Nationality</label>
                                        </div>
                                        <div class="col-8">
                                            <label>{{app.ID}}</label>
                                            <label>{{app.Surname}}</label>
                                            <label>{{app.FirstName}}</label>
                                            <label>{{app.PassNumber}}</label>
                                            <label>{{app.BirthDate}}</label>
                                            <label>{{app.Nationality}}</label>
                                        </div>
                                    </div>


                                    <div class="form-group row">
                                        <div v-if="status == 7">
                                            <object id="letter" style="width:830px;height:1150px;" />
                                        </div>
                                        <div v-if="status == 8">
                                            <object id="letter" style="width:830px;height:1150px;" />
                                        </div>

                                    </div>

                                    <div v-if="status == 9" class="form-group row">
                                        <div class="col-12">
                                            <div v-if="verification.AppError" class="left top16">
                                                <h3>Your visa form is not valid</h3>
                                                <h5 class="bt32">Make sure you correct these issues:</h5>
                                                <p v-if="verification.DataOK == 'N'">
                                                    Incorrect information: check form details
                                                </p>
                                                <p v-if="verification.PassportOK == 'N'">
                                                    Invalid Passport: Upload Passport
                                                </p>
                                                <p v-if="verification.PhotoOK == 'N'">
                                                    Invalid Photo: Upload Photo
                                                </p>
                                            </div>

                                            <div v-if="verification.OtherOK == 'N'" class="comments">
                                                <p>{{verification.Comments}}</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div v-if="status == 9" class="col-sm-12 submit-row">
                                        <router-link to="/appdetails">
                                            <button type="button" class="btn-submit">Proceed to Application</button>
                                        </router-link>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div> <!-- row reg-box -->

                </div> <!-- container-fluid wrapper -->
            </div> <!-- main registration reg -->

        </div>
        <div v-else class="bg white s_768">
            <div class="d-flex flex-column flex-md-row align-items-center mb-3 bg-white">
                <div class="container-fluid wrapper index">
                    <div class="nav-top row">
                        <div class="col-4">
                            <router-link to="/home">
                                <img class="logo-img" id="logo-btn" src="images/logo.png" />
                            </router-link>
                        </div>
                        <div class="col-8">
                            <div class="navigation">
                                <TopMenu :ShowContinueSubmission=true></TopMenu>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 top64">
                    <div class="left-links hrz-menu">
                        <label class="done">Visa fee</label>
                        <label class="done">Application</label>
                        <label class="done">Documents</label>
                        <label class="passive" href="#">Check status</label>
                    </div>
                </div>
            </div>
            <div class="row top16">
                <div class="col-12 box">
                    <h2 v-if="status == 1">Application is in progress</h2>
                    <h2 v-if="status == 4">Verification is in progress</h2>
                    <h2 v-if="status == 5">Verification is in progress</h2>
                    <h2 v-if="status == 6">Application is in progress</h2>
                    <h2 v-if="status == 7">Application is approved</h2>
                    <h2 v-if="status == 8">Application is rejected</h2>
                    <h2 v-if="status == 9">Application is not verified</h2>
                </div>

            </div>
            <div class="form-group row top16">
                <div class="col-4">
                    <label>Application number</label>
                    <label>Surname</label>
                    <label>First name</label>
                    <label>Passport number</label>
                    <label>Date of birth</label>
                    <label>Nationality</label>
                </div>
                <div class="col-8">
                    <label>{{app.ID}}</label>
                    <label>{{app.Surname}}</label>
                    <label>{{app.FirstName}}</label>
                    <label>{{app.PassNumber}}</label>
                    <label>{{app.BirthDate}}</label>
                    <label>{{app.Nationality}}</label>
                </div>
            </div>
            <div class="form-group row top16">
                <div class="col-12">
                    <div v-if="status == 7">
                        <object id="letter" style="width:100%;height:1150px;" />
                    </div>
                    <div v-if="status == 8">
                        <object id="letter" style="width:100%;height:1150px;" />
                    </div>
                </div>
                

            </div>
            <div v-if="status == 9" class="form-group row top16">
                <div class="col-12">
                    <div v-if="verification.AppError">
                        <h3>Your visa form is not valid</h3>
                        <br />
                        <h5>Make sure you correct these issues:</h5>
                        <br />
                        <p v-if="verification.DataOK == 'N'">
                            Incorrect information: check form details
                        </p>
                        <p v-if="verification.PassportOK == 'N'">
                            Invalid Passport: Upload Passport
                        </p>
                        <p v-if="verification.PhotoOK == 'N'">
                            Invalid Photo: Upload Photo
                        </p>
                    </div>

                    <div v-if="verification.OtherOK == 'N'" class="comments">
                        <p>{{verification.Comments}}</p>
                    </div>
                    <br />
                    <div v-if="status == 9" class="submit-row">
                        <router-link to="/appdetails">
                            <button type="button" class="btn-submit">Proceed to Application</button>
                        </router-link>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="placeholder top16">
                        <img src="/images/bird-app-768.jpg" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import TopMenu from "./Menu";
    export default {
        components: { TopMenu },
        name: 'Status',

        data: () => ({
            errors: [],
            verification:{},
            status: -1,
            app: {},
            windowWidth: window.innerWindow
        }),
        watch: {
            windowWidth(newWidth, oldWidth) {
                //console.log ("it changed to "+newWidth+" from " +oldWidth);
            }
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.onResize);
        },
        mounted() {
            this.windowWidth = window.innerWidth;
            this.$nextTick(() => {
                window.addEventListener('resize', this.onResize);
            }),
            this.verification.PhotoError = false;
            this.verification.AppError = false;
            this.getStatus()
        },
        computed: {
            appNum: function () {
                //return this.$store.state.appNum;
                return this.$cookie.get('eVisaAppID');
            }
        },
        methods: {
            onResize() {
                this.windowWidth = window.innerWidth
            },
            async getStatus() {
                try {
                    const response = await fetch(this.$apiip + '/api/v1/application/' + this.appNum + '/getstatus')
                    const data = await response.json()
                    this.status = data
                    if(this.status > 0){
                        
                        this.getApplication()
                    }
                    if(this.status == 9){
                        this.getVerification() 
                    }
                } catch (error) {
                    //console.error(error)
                }
            },
              async getApplication() {
                try {

                    const response = await fetch(this.$apiip + '/api/v1/application/' + this.appNum + '/status')
                    const data = await response.json()
                    this.result = data
                    this.app = data.Model
                    if (this.result.Status == 1) {
                        if (this.result.Model.Letter != null) {
                            var _src = "data:application/pdf;base64, " + this.result.Model.Letter;
                            $("#letter").attr("data", _src);
                        }

                    } else {

                        var status = kendo.jQuery('.status')
                        status.text('Oops! Application does not exist.')
                            .removeClass('alert-success')
                            .addClass('alert-danger')
                    }
                } catch (error) {
                    console.error(error)
                }
            },
            async getVerification() {
                try {
                    const response = await fetch(this.$apiip + '/api/v1/application/' + this.appNum + '/verification')
                    const data = await response.json()
                    if(data != null){
                       this.verification = data;
                       if(this.verification.DataOK == "N" || this.verification.PassportOK == "N" || this.verification.OtherOK == "N"){
                            this.verification.AppError = true
                       }
                       if(this.verification.PhotoOK == "N"){
                           this.verification.AppError = true
                       }
                    }
                } catch (error) {
                    console.error(error)
                }
            },
        }
    }
</script>

<style scoped>
</style>